module.exports = __webpack_public_path__ + "img/alex_situations.6f900f0e.svg";